import { GiftOutlined, UserOutlined } from '@ant-design/icons';
import { App, Button, Form, Input, InputNumber, Modal, Spin } from 'antd';
import bg_home from 'assets/images/bg_home.png';
import flag_left from 'assets/images/flag_left.png';
import flag_right from 'assets/images/flag_right.png';
import Countdown from 'components/Countdown/Countdown';
import HeaderMenu from 'components/Header/HeaderMenu';
import HistoryPredictions from 'components/HistoryPredictions';
import { SITE } from 'config/config';
import dayjs from 'dayjs';
import qs from 'query-string';
import React, { useEffect, useState } from 'react';
import {
  createPredictions,
  getAllSetting,
  getFP,
  getIP,
  getMatchList,
  getTime
} from 'service/base';
import { twMerge } from 'tailwind-merge';
import { CONST_SITE } from 'utils/common/const';
import RulePage from './rulePage';

const daysOfWeek = {
  Monday: 'Thứ Hai',
  Tuesday: 'Thứ Ba',
  Wednesday: 'Thứ Tư',
  Thursday: 'Thứ Năm',
  Friday: 'Thứ Sáu',
  Saturday: 'Thứ Bảy',
  Sunday: 'Chủ Nhật'
};

const leagues = [
  {
    id: 1,
    name: 'UEFA Champions League',
    logo: 'https://upload.wikimedia.org/wikipedia/en/thumb/f/f5/UEFA_Champions_League.svg/1024px-UEFA_Champions_League.svg.png'
  },
  {
    id: 2,
    name: 'UEFA Europa League',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Europa_League_2021.svg/795px-Europa_League_2021.svg.png'
  },
  {
    id: 3,
    name: 'English Premier League',
    logo: 'https://loodibee.com/wp-content/uploads/Premier-League-Logo.png'
  },
  {
    id: 4,
    name: 'La Liga',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/LaLiga_logo_2023.svg/1200px-LaLiga_logo_2023.svg.png'
  },
  {
    id: 5,
    name: 'Italian Serie A',
    logo: 'https://1000logos.net/wp-content/uploads/2019/01/Italian-Serie-A-Logo.png'
  },
  {
    id: 6,
    name: 'German Bundesliga',
    logo: 'https://upload.wikimedia.org/wikipedia/en/thumb/d/df/Bundesliga_logo_%282017%29.svg/1200px-Bundesliga_logo_%282017%29.svg.png'
  },
  {
    id: 7,
    name: 'France Ligue 1',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/Logo_Ligue_1_McDonald%27s_2024.svg/250px-Logo_Ligue_1_McDonald%27s_2024.svg.png'
  },
  {
    id: 8,
    name: 'FIFA World Cup',
    logo: 'https://upload.wikimedia.org/wikipedia/vi/thumb/1/17/2026_FIFA_World_Cup_emblem.svg/162px-2026_FIFA_World_Cup_emblem.svg.png'
  }
];

const C168Page = () => {
  const [isModalHistory, setIsModalHistory] = useState(false);
  const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);
  const { notification } = App.useApp();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [listDataMatch, setListDataMatch] = useState([]);
  const [timeServer, setTimeServer] = useState(null);
  const [IP, setIP] = useState(null);
  const [FP, setFP] = useState(null);
  const [dataSettings, setDataSettings] = useState([]);
  const [isModalRule, setIsModalRule] = useState(false);
  const [isPredictConfirmOpen, setIsPredictConfirmOpen] = useState(false);

  const [selectedLeagues, setSelectedLeagues] = useState([]);
  const [activeTab, setActiveTab] = useState('all'); // 'all', 'today', 'tomorrow'
  const [pendingMatchPredictions, setPendingMatchPredictions] = useState([]);

  // Hàm lọc trận đấu theo tab được chọn
  const getFilteredMatches = () => {
    if (!listDataMatch || listDataMatch.length === 0) return [];

    const now = dayjs();
    const today = now.format('YYYY-MM-DD');
    const tomorrow = now.add(1, 'day').format('YYYY-MM-DD');

    switch (activeTab) {
      case 'today':
        return listDataMatch.filter((match) => {
          const matchDate = dayjs.unix(match.startTime).format('YYYY-MM-DD');
          return matchDate === today;
        });
      case 'tomorrow':
        return listDataMatch.filter((match) => {
          const matchDate = dayjs.unix(match.startTime).format('YYYY-MM-DD');
          return matchDate === tomorrow;
        });
      case 'all':
      default:
        return listDataMatch;
    }
  };

  const handleLeagueClick = (leagueId) => {
    setSelectedLeagues((prevSelectedLeagues) =>
      prevSelectedLeagues.includes(leagueId)
        ? prevSelectedLeagues.filter((id) => id !== leagueId)
        : [...prevSelectedLeagues, leagueId]
    );
  };

  const [scrollPosition, setScrollPosition] = useState(0);
  const leagueListRef = React.createRef();

  const scrollLeft = () => {
    if (leagueListRef.current) {
      leagueListRef.current.scrollBy({ left: -100, behavior: 'smooth' });
      setScrollPosition(leagueListRef.current.scrollLeft - 100);
    }
  };

  const scrollRight = () => {
    if (leagueListRef.current) {
      leagueListRef.current.scrollBy({ left: 100, behavior: 'smooth' });
      setScrollPosition(leagueListRef.current.scrollLeft + 100);
    }
  };

  useEffect(() => {
    fetchAllSetting();
    fetchIP();
    fetchFP();
    fetchTimeServer();
  }, []);

  useEffect(() => {
    fetchDataScheduByLS();
    // Load saved account from localStorage
    const savedAccount = localStorage.getItem('saved_account');
    if (savedAccount) {
      form.setFieldsValue({ account: savedAccount });
    }
  }, [form]);

  const fetchIP = async () => {
    try {
      const res = await getIP();
      setIP(res);
    } catch (e) {}
  };

  const fetchFP = async () => {
    try {
      const res = await getFP();
      setFP(res);
    } catch (e) {}
  };

  const fetchTimeServer = async () => {
    try {
      const res = await getTime();
      setTimeServer(res);
    } catch (e) {}
  };

  const fetchDataScheduByLS = async () => {
    try {
      setIsLoading(true);
      const res2 = await getMatchList({
        site: CONST_SITE.C168
      });

      const dataMatch2 =
        res2?.data?.length > 0
          ? res2.data.map((item) => {
              const formatCountDown = dayjs.unix(item.startTime);
              return { ...item, countdown: new Date(formatCountDown) };
            })
          : [];

      setListDataMatch(dataMatch2 || []);
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching match list:', error);
      setIsLoading(false);
    }
  };

  const fetchAllSetting = async (data) => {
    try {
      setIsLoading(true);
      const res = await getAllSetting(qs.stringify({ site: CONST_SITE.C168 }));
      setDataSettings(res?.data || []);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const TIMEOUT_DURATION = 10000; // 10 seconds

  const createPredictionsWithTimeout = (predictions) => {
    return Promise.race([
      createPredictions(predictions),
      new Promise((_, reject) =>
        setTimeout(() => reject(new Error('Request timed out')), TIMEOUT_DURATION)
      )
    ]);
  };

  const onConfirmMatchPrediction = async () => {
    if (pendingMatchPredictions.length === 0) {
      setIsPredictConfirmOpen(false);
      return;
    }

    try {
      setIsLoadingSubmit(true);

      const res = await createPredictionsWithTimeout(pendingMatchPredictions);
      if (res?.code === 0) {
        // Save account to localStorage on success
        const account = pendingMatchPredictions[0]?.account;
        if (account) {
          localStorage.setItem('prediction_account', account);
        }

        notification.success({
          message: 'Thành công',
          description: 'Dự đoán tỉ số thành công!'
        });
        form.resetFields(Object.keys(form.getFieldsValue()).filter((key) => key !== 'account'));
        setIsPredictConfirmOpen(false);
        setPendingMatchPredictions([]);
        // Reload match list
        fetchDataScheduByLS();
      } else {
        if (res.valid === false) {
          notification.error({
            message: res.title_mess,
            description: res?.text_mess
          });
        } else {
          notification.error({
            message: 'Lỗi',
            description: res?.message
          });
        }
      }
      setIsLoadingSubmit(false);
    } catch (error) {
      notification.error({
        message: 'Lỗi',
        description: error.message || 'Đã xảy ra lỗi khi gửi dự đoán!'
      });
      setIsLoadingSubmit(false);
    }
  };

  const onFinishForm = async (data) => {
    try {
      const filteredMatches = getFilteredMatches();
      if (filteredMatches?.length === 0) return;

      if (!data?.account) {
        notification.warning({
          message: 'Cảnh báo',
          description: 'Vui lòng nhập tên đăng nhập!'
        });
        return;
      }

      // Validate that both home and away scores are provided for each match
      // Kiểm tra từng trận: nếu đã điền homeScore hoặc awayScore thì phải điền đủ cả hai và sameScore
      const matchIds = Object.keys(data)
        .filter((key) => key.startsWith('homeScore_') || key.startsWith('awayScore_'))
        .map((key) => key.split('_')[1]);

      const uniqueMatchIds = Array.from(new Set(matchIds));

      const hasInvalidScores = uniqueMatchIds.some((matchId) => {
        const homeScore = data[`homeScore_${matchId}`];
        const awayScore = data[`awayScore_${matchId}`];
        const sameScore = data[`sameScore_${matchId}`];

        const hasHome = homeScore !== undefined && homeScore !== null && homeScore !== '';
        const hasAway = awayScore !== undefined && awayScore !== null && awayScore !== '';
        const hasSame = sameScore !== undefined && sameScore !== null && sameScore !== '';

        // Nếu đã điền 1 trong 2 tỉ số thì phải điền đủ cả hai và sameScore
        if ((hasHome || hasAway) && (!hasHome || !hasAway || !hasSame)) {
          return true;
        }
        return false;
      });

      if (hasInvalidScores) {
        notification.warning({
          message: 'Cảnh báo',
          description:
            'Vui lòng nhập đầy đủ cả hai bên tỉ số và số người dự đoán giống bạn cho mỗi trận đấu!'
        });
        return;
      }

      console.log('filteredMatches', filteredMatches);
      const resultGroup = groupScoresByMatchId(data, IP, FP, filteredMatches);

      if (resultGroup.length === 0) {
        notification.warning({
          message: 'Cảnh báo',
          description: 'Vui lòng điền đẩy đủ thông tin và dự đoán ít nhất một trận đấu!'
        });
        return;
      }

      // Open confirm popup before submitting
      setPendingMatchPredictions(resultGroup);
      setIsPredictConfirmOpen(true);
    } catch (error) {
      notification.error({
        message: 'Lỗi',
        description: error.message || 'Đã xảy ra lỗi khi gửi dự đoán!'
      });
      setIsLoadingSubmit(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    if (!errorInfo?.values?.account) {
      notification.warning({
        message: 'Cảnh báo',
        description: 'Vui lòng nhập tên đang nhập!'
      });
    } else {
      notification.warning({
        message: 'Cảnh báo',
        description: 'Vui lòng điền đầy đủ thông tin!'
      });
    }
  };

  const onFinishCountDown = () => {
    console.log('finished!');
  };

  const onCancelMatchConfirm = () => {
    setIsPredictConfirmOpen(false);
  };

  const handleOpenSchedule = () => {
    setIsScheduleModalOpen(true);
  };

  const groupScoresByMatchId = (input, ip, fp, matchInfo) => {
    // Gom lại từng trận, nhận cả trường sameScore
    const groupedMatches = {};
    Object.keys(input).forEach((key) => {
      if (key === 'account') return;
      const parts = key.split('_');
      if (parts.length !== 2) return;
      const [scoreType, matchId] = parts;
      if (!matchId || !['homeScore', 'awayScore', 'sameScore'].includes(scoreType)) return;
      if (!groupedMatches[matchId]) {
        groupedMatches[matchId] = {
          matchId,
          account: input.account,
          homeScore: undefined,
          awayScore: undefined,
          sameScore: undefined
        };
      }
      if (scoreType === 'homeScore') groupedMatches[matchId].homeScore = input[key];
      if (scoreType === 'awayScore') groupedMatches[matchId].awayScore = input[key];
      if (scoreType === 'sameScore') groupedMatches[matchId].sameScore = input[key];
    });

    return Object.values(groupedMatches)
      .filter(
        (match) =>
          match.homeScore !== undefined &&
          match.awayScore !== undefined &&
          match.sameScore !== undefined &&
          match.homeScore !== null &&
          match.awayScore !== null &&
          match.sameScore !== null &&
          match.homeScore !== '' &&
          match.awayScore !== '' &&
          match.sameScore !== ''
      )
      .map(({ matchId, account, homeScore, awayScore, sameScore }) => {
        const matchDetails = matchInfo.find(
          (match) => parseInt(match.matchId) === parseInt(matchId)
        );
        return {
          matchId,
          homeScore,
          awayScore,
          sameScore,
          account,
          ip,
          fp,
          homeName: matchDetails ? matchDetails.homeName : 'Unknown',
          awayName: matchDetails ? matchDetails.awayName : 'Unknown',
          site: SITE
        };
      });
  };

  const showListItemMatch = (matchList) => {
    if (!matchList || matchList.length <= 0) {
      return (
        <div className="flex items-center justify-center">
          <p className="text-center">Hiện tại không có trận đấu nào để dự đoán</p>
        </div>
      );
    } else {
      const filteredMatchList =
        selectedLeagues.length > 0
          ? matchList.filter((item) =>
              selectedLeagues.includes(
                leagues.find(
                  (league) =>
                    league.name === item.leagueName || item.leagueName.startsWith(league.name)
                )?.id
              )
            )
          : matchList;

      const itemMatch = filteredMatchList
        .filter((item) => timeServer <= item.countdown) // Filter out matches that have ended
        .map((item, index) => {
          const matchDayOfWeek = daysOfWeek[dayjs(item.startTime * 1000).format('dddd')]; // Calculate day of week for each match
          return (
            <div
              className={twMerge(
                'flex items-center w-[95%] xl:w-3/4 md:w-4/5 mx-auto bg-white rounded-2xl px-2 text-sm font-medium gap-2 border flex-col shadow-[0_0_10.574px_0_rgba(0,0,0,0.09)_inset] pb-3 mt-2',
                timeServer > item.countdown ? 'contrast-50' : ''
              )}
              key={index}
              style={{
                backgroundImage: `url(assets/images/match/bg.png)`,
                backgroundSize: 'cover'
              }}
            >
              <div
                className={twMerge(
                  'italic text-center w-auto ',
                  'px-5 md:px-10',
                  'rounded-b-[10.448px]',
                  'bg-[#26A9E0]',
                  'shadow-[0_2.09px_10.448px_0_rgba(0,0,0,0.25)]'
                )}
              >
                <p className="text-white text-center font-roboto font-bold leading-normal pt-2 pb-2 not-italic text-xs sm:text-sm md:text-base lg:text-lg">
                  {item?.leagueName}
                </p>
              </div>
              <div className="flex flex-col md:flex-row justify-center md:justify-around gap-0 md:gap-6 w-full items-center text-xs sm:text-sm md:text-base pb-3">
                <div className="flex flex-row items-center ">
                  <span className="flex flex-row items-center h-full">
                    <span
                      className={`mr-1 flex items-center h-full md:text-[16px] text-[14px] ${
                        timeServer > item.countdown ? 'text-red-500' : 'text-black'
                      }`}
                    >
                      {timeServer > item.countdown ? 'Hết giờ' : 'Thời gian dự đoán còn: '}
                    </span>
                    <div className="countdown-responsive">
                      <Countdown
                        value={item.countdown}
                        onFinish={onFinishCountDown}
                        format="HH:mm:ss"
                        style={{ color: '#26a9e0', fontWeight: 600 }}
                      />
                      <style>
                        {`
                          .countdown-responsive .ant-statistic-content {
                            font-size: 14px;
                          }
                          @media (min-width: 768px) {
                            .countdown-responsive .ant-statistic-content {
                              font-size: 16px;
                            }
                          }
                        `}
                      </style>
                    </div>
                  </span>
                </div>
                <span className="flex items-center text-black">
                  <span className="flex items-center h-full md:text-[16px] text-[14px]">
                    Thời gian kết thúc:{' '}
                  </span>
                  <span className="text-[#26A9E0] ml-1 font-semibold flex items-center h-full  md:text-[16px] text-[14px]">
                    {dayjs(item.startTime * 1000).format('HH:mm')}
                  </span>
                </span>
              </div>
              <div className="flex flex-row items-end justify-center gap-[22px] w-full py-4">
                {/* Home Team */}
                <div className="flex flex-col gap-[11px] items-center w-full max-w-[160px] ">
                  <div className="bg-white flex items-center justify-center p-[10px] rounded-full w-[100px] h-[100px]">
                    <img
                      src={item.homeLogo}
                      className="w-[68px] h-[68px] object-contain"
                      alt={item.homeName}
                    />
                  </div>
                  <p className="capitalize font-medium text-[13px] text-black text-center w-full">
                    {item.homeName}
                  </p>
                </div>

                {/* VS and Time */}
                <div className="relative w-[163px] h-[91px]">
                  <div className="absolute bottom-0 left-0 w-full h-[45px] flex items-center justify-center px-[6px] py-[5px] rounded-t-[4px]">
                    <div className="font-semibold text-[#26a9e0] text-center">
                      <p className="font-bold text-[23px] mb-0 leading-none">
                        {dayjs(item.startTime * 1000).format('HH:mm')}
                      </p>
                      <p className="text-[11px] leading-none mt-1">
                        {`${matchDayOfWeek}, ${dayjs(item.startTime * 1000).format('DD/MM/YYYY')}`}
                      </p>
                    </div>
                  </div>
                  <img
                    src="assets/images/match/vs.png"
                    alt="VS"
                    className="absolute top-0 left-1/2 -translate-x-1/2 w-auto h-[38px]"
                  />
                </div>

                {/* Away Team */}
                <div className="flex flex-col gap-[13px] items-center w-full max-w-[160px] ">
                  <div className="flex items-center justify-center p-[10px] rounded-full w-[100px] h-[100px] bg-white">
                    <img
                      src={item.awayLogo}
                      className="w-[68px] h-[68px] object-contain"
                      alt={item.awayName}
                    />
                  </div>
                  <p className="capitalize font-medium text-[13px] text-black text-center w-full">
                    {item.awayName}
                  </p>
                </div>
              </div>
              <div className="flex flex-col w-full sm:w-3/4 justify-center items-center px-2">
                <div className="flex md:justify-around justify-center flex-row items-center p-1 gap-3 sm:gap-5 md:gap-16">
                  <Form.Item className="m-0 p-0" name={`homeScore_${item.matchId}`}>
                    <InputNumber
                      disabled={timeServer > item.countdown ? true : false}
                      controls={false}
                      min={0}
                      max={99}
                      maxLength={2}
                      placeholder="Nhập số"
                      className="bg-white border-0 w-[70px] sm:w-[90px] md:w-[145px] h-[34px] sm:h-[37px] md:h-[40px] text-center text-xs sm:text-sm md:text-base font-normal text-[#505050] shadow-[0px_1.057px_4.23px_0px_inset_rgba(0,0,0,0.29)] rounded-md"
                      style={{
                        textAlign: 'center',
                        fontFamily: "'Roboto', sans-serif"
                      }}
                    />
                  </Form.Item>
                  <span className="font-bold text-black text-sm sm:text-base md:text-lg whitespace-nowrap px-1">
                    Tỉ số
                  </span>
                  <Form.Item className="m-0 p-0" name={`awayScore_${item.matchId}`}>
                    <InputNumber
                      disabled={timeServer > item.countdown ? true : false}
                      controls={false}
                      min={0}
                      max={99}
                      maxLength={2}
                      placeholder="Nhập số"
                      className="bg-white border-0 w-[70px] sm:w-[90px] md:w-[145px] h-[34px] sm:h-[37px] md:h-[40px] text-center text-xs sm:text-sm md:text-base font-normal text-[#505050] shadow-[0px_1.057px_4.23px_0px_inset_rgba(0,0,0,0.29)] rounded-md"
                      style={{
                        textAlign: 'center',
                        fontFamily: "'Roboto', sans-serif"
                      }}
                    />
                  </Form.Item>
                </div>
                <div className="flex justify-between flex-row items-center p-1 gap-16">
                  <Form.Item className="m-0 p-0" name={`sameScore_${item.matchId}`}>
                    <InputNumber
                      disabled={timeServer > item.countdown ? true : false}
                      controls={false}
                      min={0}
                      maxLength={5}
                      placeholder="Số người dự đoán giống bạn"
                      className="bg-white border-0 !w-[290px] h-[37px] text-center text-[14.804px] font-normal text-[#505050] shadow-[0px_1.057px_4.23px_0px_inset_rgba(0,0,0,0.29)]"
                      style={{
                        textAlign: 'center',
                        fontFamily: "'Roboto', sans-serif"
                      }}
                    />
                  </Form.Item>
                </div>
              </div>
              <div className="flex flex-row w-full sm:w-3/4 justify-center mt-2">
                <Button
                  type="primary"
                  htmlType="submit"
                  className="rounded-[40px] border-[0.8px] border-[#F4F4F4] bg-[#26A9E0] shadow-[0px_0px_4px_0px_#63c8f2,0px_0px_20px_0px_#63c8f2_inset] flex w-[140px] sm:w-[163px] h-[38px] sm:h-[40px] md:h-[44px] px-4 sm:px-5 py-2.5 sm:py-3 justify-center items-center text-white font-semibold text-sm sm:text-base"
                >
                  <span className="flex items-center justify-center w-full">Xác Nhận</span>
                </Button>
              </div>
            </div>
          );
        });

      if (!itemMatch || itemMatch.length <= 0) {
        return (
          <div className="flex items-center justify-center">
            <p className="text-center">Hiện tại không có trận đấu nào để dự đoán</p>
          </div>
        );
      }
      return itemMatch;
    }
  };

  return (
    <div className="w-full h-full flex flex-col">
      <img
        src={bg_home}
        alt="Background"
        className="w-full h-full fixed right-0 bottom-0 object-cover -z-10"
      />
      <img
        src={flag_left}
        alt="Flag left"
        className="fixed md:top-0 top-20 left-0 z-0 w-[120px] md:w-[180px] lg:w-[220px] h-auto pointer-events-none"
      />
      <img
        src={flag_right}
        alt="Flag right"
        className="fixed md:top-0 top-20 right-0 z-0 w-[120px] md:w-[180px] lg:w-[220px] h-auto pointer-events-none"
      />
      <div className="relative z-10">
        {/* <Header /> */}
        <HeaderMenu onScheduleClick={handleOpenSchedule} onRuleClick={() => setIsModalRule(true)} />
        <div className="mx-auto w-full md:pb-2 rounded-t-[34px] px-2">
          {/* <div className="flex space-x-6 mt-1 lg:mt-3 justify-center items-center">
            <Button
              type="link"
              icon={<LeftOutlined />}
              onClick={scrollLeft}
              className="text-[#26A9E0] !px-0 !mx-0"
            />
            <div
              className="flex overflow-x-auto scrollbar-custom pt-1 pb-2 !mx-0"
              ref={leagueListRef}
              style={{ scrollBehavior: 'smooth' }}
            >
              {leagues.map((league) => (
                <div
                  key={league.id}
                  className={twMerge(
                    'flex justify-center items-center p-1 mx-2 rounded-lg cursor-pointer transition-all duration-300 hover:scale-105',
                    selectedLeagues.includes(league.id)
                      ? 'bg-black/15 shadow-lg shadow-[#26A9E0] border-2 border-[#26A9E0]'
                      : 'bg-white/80 backdrop-blur-sm border-2 border-[#26A9E0]/30 hover:border-[#26A9E0] hover:shadow-md'
                  )}
                  style={{ width: '80px', minWidth: '80px', border: '1px solid #26A9E0' }}
                  onClick={() => handleLeagueClick(league.id)}
                >
                  <img src={league.logo} alt={league.name} className="h-12 object-contain" />
                </div>
              ))}
            </div>
            <Button
              type="link"
              icon={<RightOutlined />}
              onClick={scrollRight}
              className="text-[#26A9E0] !px-0 !mx-0"
            />
          </div> */}
          {/* <div className="w-full h-auto my-3 md:my-2">
            <div className="flex flex-wrap gap-1 sm:gap-3 lg:gap-5 items-center justify-center w-full">
              <button
                onClick={() => setActiveTab('all')}
                className={`h-[26px] sm:h-[36px] lg:h-[40px] px-2 sm:px-4 lg:px-6 py-1 rounded-[12px] sm:rounded-[18px] lg:rounded-[25px] text-[11px] lg:text-[15px] font-normal ${
                  activeTab === 'all' ? 'text-white' : 'text-[#3C3C3C]'
                } transition-all duration-200 outline-none focus:outline-none capitalize border-solid border-2 border-[#26A9E0] ${
                  activeTab === 'all' ? 'bg-[#26A9E0]' : 'bg-[#FFF]'
                }`}
              >
                Tất Cả
              </button>
              <button
                onClick={() => setActiveTab('today')}
                className={`h-[26px] sm:h-[36px] lg:h-[40px] px-2 sm:px-4 lg:px-6 py-1 rounded-[12px] sm:rounded-[18px] lg:rounded-[25px] text-[11px] lg:text-[15px] font-normal ${
                  activeTab === 'today' ? 'text-white' : 'text-[#3C3C3C]'
                } transition-all duration-200 border-solid border-2 border-[#26A9E0] outline-none focus:outline-none capitalize ${
                  activeTab === 'today' ? 'bg-[#26A9E0]' : 'bg-[#FFF]'
                }`}
              >
                Hôm Nay
              </button>
              <button
                onClick={() => setActiveTab('tomorrow')}
                className={`h-[26px] sm:h-[36px] lg:h-[40px] px-2 sm:px-4 lg:px-6 py-1 rounded-[12px] sm:rounded-[18px] lg:rounded-[25px] text-[11px] lg:text-[15px] font-normal ${
                  activeTab === 'tomorrow' ? 'text-white' : 'text-[#3C3C3C]'
                } transition-all duration-200 border-solid border-2 border-[#26A9E0] outline-none focus:outline-none capitalize ${
                  activeTab === 'tomorrow' ? 'bg-[#26A9E0]' : 'bg-[#FFF]'
                }`}
              >
                Ngày Mai
              </button>
            </div>
          </div> */}
          <div className="w-full h-full flex flex-col">
            <Form
              name="formMatch"
              onFinish={onFinishForm}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              form={form}
              initialValues={{ account: '' }}
            >
              <div className="w-full h-full">
                <div
                  className="flex flex-col max-w-[980px] mx-auto w-full h-full items-center mt-2 pb-6"
                  style={{
                    background:
                      'linear-gradient(0deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), rgba(255, 255, 255, 0.5)',
                    backgroundBlendMode: 'normal, overlay',
                    boxShadow:
                      '0px 0px 22.2698px #92DEFF, 0px 8px 12px rgba(0, 0, 0, 0.08), inset 2.02822px 2.02822px 2.02822px -2.02822px #FFFFFF, inset -2.02822px -2.02822px 2.02822px -2.02822px #FFFFFF',
                    backdropFilter: 'blur(10.1411px)',
                    WebkitBackdropFilter: 'blur(10.1411px)',
                    borderRadius: '14.0625px'
                  }}
                >
                  <div className="flex flex-col p-2 py-5 w-full md:px-6 h-full items-center">
                    <div className="flex flex-col sm:flex-row w-full h-full items-center px-3 justify-between gap-2 md:mx-3">
                      <div className="flex gap-2 md:py-4">
                        <Form.Item name="account" className="mb-0">
                          <Input
                            placeholder="Tên đăng nhập ..."
                            maxLength={20}
                            prefix={<UserOutlined />}
                            rules={[
                              {
                                required: true,
                                message: 'Vui lòng điền tên đăng nhập!'
                              }
                            ]}
                          />
                        </Form.Item>
                        <Form.Item className="mb-0">
                          <Button
                            type="primary"
                            htmlType="submit"
                            loading={isLoadingSubmit}
                            className="text-white bg-[#0053DF] font-medium rounded-[4.286px] border-0"
                            // style={{
                            //   background: 'linear-gradient(180deg, #53ADFF 0%, #0066FF 100%)'
                            // }}
                          >
                            Xác Nhận
                          </Button>
                        </Form.Item>
                      </div>
                      <div className="flex gap-2 md:py-4">
                        <Button
                          type="primary"
                          className="text-white bg-[#0053DF] font-medium rounded-[12px] border-0"
                          onClick={() =>
                            window.open('https://ls47.live/', '_blank', 'noopener,noreferrer')
                          }
                          // style={{
                          //   background: 'linear-gradient(180deg, #53ADFF 0%, #0066FF 100%)'
                          // }}
                        >
                          Xem live
                        </Button>
                      </div>
                    </div>
                    <p className="w-full mt-3 px-3 text-black text-sm md:text-base font-normal italic">
                      Nhập tên đăng nhập và tỷ số ít nhất 1 trận để dự đoán.
                    </p>

                    <div className="flex w-full h-full mt-2 items-center px-3 justify-between gap-2">
                      <Button
                        type="primary"
                        onClick={() => setIsModalHistory(true)}
                        className="text-white bg-[#0053DF] font-medium rounded-[4.286px] border-0"
                        // style={{
                        //   background: 'linear-gradient(180deg, #53ADFF 0%, #0066FF 100%)'
                        // }}
                      >
                        Lịch sử dự đoán
                      </Button>
                      <Button
                        type="primary"
                        icon={<GiftOutlined />}
                        onClick={() => setIsModalRule(true)}
                        className="text-white bg-[#0053DF] font-medium rounded-[4.286px] border-0"
                      >
                        Cơ cấu giải thưởng
                      </Button>
                    </div>
                  </div>

                  {isLoading ? (
                    <div className="w-full h-full text-center py-8">
                      <Spin />
                    </div>
                  ) : (
                    <div className="w-full h-full flex flex-col gap-2 mt-1 md:-mt-2">
                      {showListItemMatch(getFilteredMatches())}
                    </div>
                  )}
                </div>
                <div className="flex items-center justify-between mt-2"></div>
              </div>
            </Form>
          </div>
        </div>
      </div>

      {isPredictConfirmOpen ? (
        <div className="fixed inset-0 z-[60] flex items-center justify-center px-3">
          <div
            className="absolute inset-0 bg-black/20"
            aria-hidden="true"
            onClick={isLoadingSubmit ? undefined : onCancelMatchConfirm}
          />

          <div
            role="dialog"
            aria-modal="true"
            aria-label="Xác nhận dự đoán trận đấu"
            className="relative w-full max-w-[520px] bg-[#d4edf7] border-[2.289px] border-solid border-white rounded-[10px] p-[18px] md:p-[30px] backdrop-blur-[24.266px]"
          >
            <div className="flex justify-center mb-3">
              <div className="w-[68px] h-[68px] md:w-[80px] md:h-[80px] bg-[#4cd964] rounded-full flex items-center justify-center shadow-lg">
                <svg
                  className="w-[40px] h-[40px] md:w-[50px] md:h-[50px] text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={3}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
            </div>

            <div className="text-center font-extrabold text-[#26a9e0] text-[20px] md:text-[24px] leading-[32px] md:leading-[40px]">
              XÁC NHẬN DỰ ĐOÁN
            </div>

            <div className="mt-2 text-center text-[#2a2a2a] font-medium text-[14px] md:text-[16px] leading-[22px] md:leading-[26px]">
              <div className="mb-2">Bạn đã chọn dự đoán các trận đấu sau:</div>

              <div className="max-h-[300px] overflow-y-auto space-y-2 px-2">
                {pendingMatchPredictions.map((match, index) => (
                  <div key={match.matchId || index} className="bg-white/60 rounded-lg p-2 md:p-3">
                    <div className="font-bold text-[#333]">
                      {match.homeName} - {match.awayName}
                    </div>
                    <div className="text-[#26a8df] font-bold text-[16px] md:text-[18px]">
                      Tỷ số: {match.homeName}{' '}
                      <span className="text-[#e74c3c]">{match.homeScore}</span> -{' '}
                      <span className="text-[#e74c3c]">{match.awayScore}</span> {match.awayName}
                    </div>
                    <div className="text-[#666] text-[12px] md:text-[14px]">
                      Số người dự đoán giống bạn:{' '}
                      <span className="font-bold text-[#26a8df]">{match.sameScore}</span>
                    </div>
                    {match.firstGoal && (
                      <div className="text-[#666] text-[12px] md:text-[14px]">
                        Đội ghi bàn đầu tiên:{' '}
                        <span className="font-bold text-[#26a8df]">
                          {match.firstGoal === 'home' ? match.homeName : match.awayName}
                        </span>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              <div className="mt-3 italic text-[13px] md:text-[14px]">
                Hãy cùng chờ đợi kết quả nhé.
              </div>
            </div>

            <div className="mt-4 flex items-center justify-center gap-[18px]">
              <button
                type="button"
                disabled={isLoadingSubmit}
                onClick={onConfirmMatchPrediction}
                className={twMerge(
                  'w-[143.5px] h-[38px] md:h-auto border-none bg-[#26a8df] text-white rounded-[9.965px] px-[9.965px] py-[9.965px] font-semibold text-[13.951px]',
                  isLoadingSubmit ? 'opacity-60 cursor-not-allowed' : ''
                )}
              >
                {isLoadingSubmit ? 'ĐANG GỬI...' : 'XÁC NHẬN'}
              </button>

              <button
                type="button"
                disabled={isLoadingSubmit}
                onClick={onCancelMatchConfirm}
                className={twMerge(
                  'w-[143.5px] h-[38px] md:h-auto border-none bg-[#a2b1b8] text-white rounded-[9.965px] px-[9.965px] py-[9.965px] font-semibold text-[13.951px]',
                  isLoadingSubmit ? 'opacity-60 cursor-not-allowed' : ''
                )}
              >
                HỦY BỎ
              </button>
            </div>
          </div>
        </div>
      ) : null}

      <RulePage isModalRule={isModalRule} setIsModalRule={setIsModalRule} />

      <Modal
        open={isScheduleModalOpen}
        onCancel={() => setIsScheduleModalOpen(false)}
        footer={null}
        width={1000}
        centered
        destroyOnClose
        title={<span className="font-bold text-[#000]">LỊCH THI ĐẤU HOT</span>}
      >
        <div className="pt-1">
          <iframe
            src="https://football-widget.pages.dev/"
            width="100%"
            height="600"
            frameBorder="0"
            allowFullScreen
            title="Football Widget"
            className="w-full rounded-lg"
          />
        </div>
      </Modal>

      <HistoryPredictions
        isModalVote={isModalHistory}
        setIsModalVote={setIsModalHistory}
        IP={IP}
        FP={FP}
      />
    </div>
  );
};

export default C168Page;
